import React from 'react';
import {useTranslation} from 'react-i18next';

export default function LanguageSwitcher(){
  const {i18n}=useTranslation();
  const language=i18n.language==='bn'?'bn':'en';
  const select=(event,lng)=>{i18n.changeLanguage(lng);event.currentTarget.closest('details').open=false;};
  return <details className="language-menu"><summary aria-label="Choose language"><span aria-hidden="true">{language==='bn'?'🇧🇩':'🌐'}</span> {language==='bn'?'বাংলা':'English'}</summary><div className="language-options"><button type="button" aria-current={language==='en'?'true':undefined} onClick={event=>select(event,'en')}><span aria-hidden="true">🌐</span> English</button><button type="button" aria-current={language==='bn'?'true':undefined} onClick={event=>select(event,'bn')}><span aria-hidden="true">🇧🇩</span> বাংলা</button></div></details>;
}
